import SsnCompanyIdValidationService from "@validation/Services/SsnCompanyIdValidationService";
import { InputType } from "@validation/Models/InputType";

const validationService = new SsnCompanyIdValidationService();

export const validateCodeCompany = (text: string) => {
    const validCompanyCode = validationService.getInputType(text);
  const validLastCharacter = validationService.calculateCompanyIdControlMark(
    text,
  );
  const lastCharacter = text[text.length - 1];

    return validLastCharacter !== null && lastCharacter === validLastCharacter && validCompanyCode == InputType.CompanyId;
};
export const validateCodePerson = (text: string) => {
    const validSSNCode = validationService.getInputType(text);
    const validLastCharacter = validationService.calculateSsnControlCharacter(
        text,
    );
    const lastCharacter = text[text.length - 1];

    return validLastCharacter !== null && lastCharacter === validLastCharacter && validSSNCode == InputType.SSN;
};
